<template>
  <div class="imprint">
    <modal v-if="isModalOpen" @close="closeModal">
      <div slot="header" class="imprint__header">
        <h1>{{ $t('Web.imprint.title') }}</h1>
      </div>
      <div slot="body">
        <div>
          <h3>{{ $t('Web.imprint.address.title') }}</h3>
          <p>{{ $t('Web.imprint.address.name') }}</p>
          <p />
          <p>{{ $t('Web.imprint.address.street') }}</p>
          <p>{{ $t('Web.imprint.address.city') }}</p>
          <p>
            <a href="mailto:contact@siemens.com">contact@siemens.com</a>
          </p>
          <p>Tel. +49 89 636-00</p>
          <p>Fax +49 69 6682-6664</p>
        </div>
        <div>
          <h3>{{ $t('Web.imprint.chairman') }}</h3>
          <p>Gerhard Cromme</p>
        </div>
        <div>
          <h3>{{ $t('Web.imprint.board') }}</h3>
          <p>Joe Kaeser (Vorsitzender)</p>
          <p>Roland Busch</p>
          <p>Lisa Davis</p>
          <p>Klaus Helmrich</p>
          <p>Janina Kugel</p>
          <p>Cedrik Neike</p>
          <p>Michael Sen</p>
          <p>Ralf P. Thomas</p>
        </div>
        <div>
          <h3>{{ $t('Web.imprint.company.title') }}</h3>
          <p>{{ $t('Web.imprint.company.address') }}</p>
        </div>
        <div>
          <h3>{{ $t('Web.imprint.register.title') }}</h3>
          <p>{{ $t('Web.imprint.register.address') }}</p>
        </div>
        <div>
          <h3>{{ $t('Web.imprint.identificationNr') }}</h3>
          <p>DE129274202</p>
        </div>
        <div>
          <h3>{{ $t('Web.imprint.responsible.title') }}</h3>
          <p>Clarissa Haller</p>
          <p>{{ $t('Web.imprint.responsible.name') }}</p>
          <p>{{ $t('Web.imprint.responsible.street') }}</p>
          <p>{{ $t('Web.imprint.responsible.city') }}</p>
          <br />
        </div>
        <p>
          {{ $t('Web.imprint.currentUpdate.date') }}
          <br />
          {{ $t('Web.imprint.currentUpdate.text') }}
          <a href="https://www.siemens.com/corp/de/app/impressum.htm?stop_mobi=true">{{
            $t('Web.imprint.currentUpdate.leadTo')
          }}</a
          >.
        </p>
        <br />
      </div>
      <div slot="footer"></div>
    </modal>
  </div>
</template>

<script>
import Modal from '../_common/modal.vue';

export default {
  name: 'Imprint',
  components: { Modal },
  data() {
    return {
      isModalOpen: true
    };
  },
  created() {},
  computed: {},
  methods: {
    closeModal() {
      // if there is a previous route, navigate to it. Otherwise go to home route.
      // We check for > 2 because an empty browser tab/page counts already as one
      // and we want to ensure that closing this modal will not lead to a blank tab/page.
      if (window.history && window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push('/home');
      }
    }
  }
};
</script>

<style lang="scss">
.imprint {
  font-family: $font-siemens;

  h1 {
    margin: 0 auto;
    text-align: center;
    font-size: 24px;
  }

  h2,
  h3 {
    margin: 48px 0 20px;
    color: $charcoal-grey;
  }

  ol > li {
    list-style: decimal;
  }

  p {
    margin: 15px 0;
  }

  li {
    margin: 0 0 0 15px;
  }

  &__body {
    padding: 0 10px 30px 10px;
    font-size: 16px;
  }
}

.imprint .modal-body div > div {
  border-bottom: 1px solid #ddd;
}
</style>
